import type {ReactElement} from 'react'

export const IconWrapper = ({hasContainer, children}: {hasContainer: boolean; children: ReactElement}) => {
  if (hasContainer) {
    return (
      <div className="relative flex size-8 items-center justify-center rounded-md bg-[#05502F]">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 22 20" fill="none">
          {children}
        </svg>
        <div className="absolute inset-0 rounded-md border border-moss-white/[20%]" />
      </div>
    )
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
      {children}
    </svg>
  )
}
